import { render, staticRenderFns } from "./VideoPost.vue?vue&type=template&id=3570b212&scoped=true"
import script from "./VideoPost.vue?vue&type=script&lang=js"
export * from "./VideoPost.vue?vue&type=script&lang=js"
import style0 from "./VideoPost.vue?vue&type=style&index=0&id=3570b212&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3570b212",
  null
  
)

export default component.exports